const isValidDimensionValue = (value) => {
    return value !== null && value !== undefined && value !== ''
}

const hasValidDimensions = (dimensionItem) => {
    if (!dimensionItem || typeof dimensionItem !== 'object') return false

    const keys = Object.keys(dimensionItem)
    if (keys.length === 0) return false

    return keys.some((key) => {
        const item = dimensionItem[key]
        return isValidDimensionValue(item?.width) || isValidDimensionValue(item?.height)
    })
}

export const hasInvalidVariantDimensions = (variants = []) => {
    if (!variants || variants.length === 0) return true

    return variants.some((variant) => {
        const dimensions = variant?.dimensions

        if (!Array.isArray(dimensions) || dimensions.length === 0) return true

        return dimensions.every((dimensionItem) => !hasValidDimensions(dimensionItem))
    })
}